import React from 'react';
import {useTranslations} from 'next-intl';
import Container from '@/container';
import {Grid, Row, Col} from '@/grid';
import {SectionPaddingHomeHero} from '@/section';
import {withMarginBottomLg, withMarginBottomZeroToLg} from '@/hocs/withSpacing';
import {withGreen800, withNeutral700, withNeutral800} from '@/hocs/withColors';
import {withHomeSubP, withHeadingEyebrow} from '@/hocs/withFontType';
import {H1, P} from '@/typography';
import Link from '@/links';
import PictureWrapper from '@/ui/images-wrapper';
import styles from './styles.module.scss';

const H1Green800 = withGreen800(H1);
const SubPNeutral800 = withNeutral800(withHomeSubP(P));
const EyebrowNeutral700 = withNeutral700(withHeadingEyebrow(P as never));
const DivMargined = withMarginBottomLg('div' as never);
const CtaDefaultMarginedMob = withMarginBottomZeroToLg(Link);

const IMG_PATH = '/static/images/industry-healthcare/';

const FluidGrid = Grid as React.ComponentType<{
  fluid?: boolean;
  className?: string;
  tagName?: string;
  children?: React.ReactNode;
}>;

const HeroSection = () => {
  const t = useTranslations('industryHealthcare.hero');
  const sharedT = useTranslations('shared');

  return (
    <SectionPaddingHomeHero>
      <Container variant="section-padding-below-nav">
        <FluidGrid fluid>
          <Row center="xs" start="lg" middle="lg">
            <Col xs={12} lg={6}>
              <EyebrowNeutral700>{t('eyebrow')}</EyebrowNeutral700>
              <H1Green800>{t('title')}</H1Green800>
              <SubPNeutral800>{t('subtitle')}</SubPNeutral800>
              <DivMargined>
                <ul className={styles['list-inline-to-bl']}>
                  <li>
                    <CtaDefaultMarginedMob
                      href="/free-trial"
                      variant="cta-default-xs"
                      customAttributes={{
                        'data-gtm': 'healthcare-hero-free-trial',
                        'data-ui': 'healthcare-hero-free-trial'
                      }}>
                      {sharedT('freeTrialCTALabel')}
                    </CtaDefaultMarginedMob>
                  </li>
                  <li>
                    <Link
                      href="/demo"
                      variant="primary"
                      customAttributes={{
                        'data-gtm': 'healthcare-hero-demo',
                        'data-ui': 'healthcare-hero-demo'
                      }}>
                      {sharedT('demoCTALabel')}
                    </Link>
                  </li>
                </ul>
              </DivMargined>
            </Col>

            <Col xs={12} lg={6}>
              <PictureWrapper
                imgPath={IMG_PATH}
                imageUrl={t('imageUrl')}
                imageTypeFallback="jpg"
                altImage={t('imageAlt')}
                rounded
                width={584}
                height={624}
                fetchpriority="high"
                loading="eager"
              />
            </Col>
          </Row>
        </FluidGrid>
      </Container>
    </SectionPaddingHomeHero>
  );
};

export default HeroSection;
